package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Paint
import androidx.compose.ui.graphics.PaintingStyle
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.drawscope.drawIntoCanvas
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.addItemMargin
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.is4K
import com.hyperether.goodjob.models.Repeat
import com.hyperether.goodjob.models.Team
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.navigation.JobDetails
import com.hyperether.goodjob.navigation.Jobs
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add
import com.hyperether.goodjob.resources.add_more
import com.hyperether.goodjob.resources.add_new_job
import com.hyperether.goodjob.resources.add_note
import com.hyperether.goodjob.resources.add_notes
import com.hyperether.goodjob.resources.add_steps
import com.hyperether.goodjob.resources.are_you_sure
import com.hyperether.goodjob.resources.assign_employee
import com.hyperether.goodjob.resources.baseline_file_present_24
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.confirmation
import com.hyperether.goodjob.resources.contact_name
import com.hyperether.goodjob.resources.contact_site
import com.hyperether.goodjob.resources.date_error
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.delete_job
import com.hyperether.goodjob.resources.due_date
import com.hyperether.goodjob.resources.end_at
import com.hyperether.goodjob.resources.enter_job_title
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.files
import com.hyperether.goodjob.resources.files_notes
import com.hyperether.goodjob.resources.job_added
import com.hyperether.goodjob.resources.job_deleted
import com.hyperether.goodjob.resources.job_details
import com.hyperether.goodjob.resources.job_start_time_error
import com.hyperether.goodjob.resources.job_status
import com.hyperether.goodjob.resources.job_title_mandatory
import com.hyperether.goodjob.resources.job_updated
import com.hyperether.goodjob.resources.max_size
import com.hyperether.goodjob.resources.never
import com.hyperether.goodjob.resources.notes
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.only_support
import com.hyperether.goodjob.resources.provide_information
import com.hyperether.goodjob.resources.repeat
import com.hyperether.goodjob.resources.repeat_interval
import com.hyperether.goodjob.resources.select_job_status
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.start_at
import com.hyperether.goodjob.resources.start_date
import com.hyperether.goodjob.resources.start_end_time
import com.hyperether.goodjob.resources.steps
import com.hyperether.goodjob.resources.success
import com.hyperether.goodjob.resources.trash
import com.hyperether.goodjob.resources.try_another_document
import com.hyperether.goodjob.resources.update_job
import com.hyperether.goodjob.resources.upload_cloud
import com.hyperether.goodjob.resources.upload_documents
import com.hyperether.goodjob.scenes.addNew.components.AddNewJobDropdownInput
import com.hyperether.goodjob.scenes.addNew.components.AssignEmployeeDropdown
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.WebViewHeaderWithRightContent
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.jobs.AppInputFieldWithUpdate
import com.hyperether.goodjob.scenes.register.AppInputField
import com.hyperether.goodjob.scenes.register.FilledButtonHeader
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BlueBackground
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import io.wojciechosak.calendar.config.SelectionMode
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import org.jetbrains.compose.resources.painterResource
import org.lighthousegames.logging.logging

@Composable
fun AddNewJobScreenWeb(
    jobId: String?,
    users: List<User>,
    teams: List<Team>,
    fileIds: List<String>,
    viewModel: AddJobViewModel,
    navHostController: NavHostController,
    onUploadDocumentClick: (String, DocumentType) -> Unit
) {

    val log = logging("AddNewJobScreenWeb")
    var selectedIndex by remember { mutableStateOf(0) }

    val startAtString = stringResource(Res.string.start_at)
    val endAtString = stringResource(Res.string.end_at)

    LaunchedEffect(Unit) {
        viewModel.init()
    }

    val scrollState = rememberScrollState()
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
            .verticalScrollbar(scrollState)
            .verticalScroll(scrollState)
            .disableMouseDragScrollOnWeb()
            .padding(bottom = addItemMargin())
    ) {
        WebViewHeaderWithRightContent(
            isBackAvailable = true,
            onBackClick = {
                jobId?.let {
                    if (jobId == DEFAULT_JOB_ID || jobId == "") {
                        navHostController.navigate(Jobs)
                    } else {
                        navHostController.navigate(JobDetails(jobId))
                    }
                }
            },
            title = if (jobId == DEFAULT_JOB_ID || jobId == "") stringResource(Res.string.add_new_job) else stringResource(
                Res.string.update_job
            )
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                if (jobId != DEFAULT_JOB_ID && jobId != "") {
                    DisableSelection {
                        Text(
                            color = Color.Red,
                            text = stringResource(Res.string.delete_job),
                            modifier = Modifier.clickableWithPointer {
                                viewModel.showAreYouSurePopUpDeleteJob.value = true
                                viewModel.selectedJobIdToDelete.value = jobId
                            },
                            fontSize = 14.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            fontWeight = FontWeight.W700
                        )
                    }
                    Spacer(modifier = Modifier.width(16.dp))
                }

                FilledButtonHeader(
                    text = if (jobId == DEFAULT_JOB_ID || jobId == "") stringResource(
                        Res.string.add
                    ) else stringResource(
                        Res.string.update_job
                    ),
                    onClick = {
                        if (jobId == DEFAULT_JOB_ID || jobId == "") {
                            viewModel.addJob(
                                onSuccess = {
                                    viewModel.showLoader.value = false
                                    viewModel.showPopUpSuccess.value = true
                                },
                                onError = {
                                    viewModel.showLoader.value = false
                                    viewModel.showPopUpError.value = true
                                })
                        } else {
                            jobId?.let {
                                viewModel.updateJob(
                                    it,
                                    onSuccess = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpSuccess.value = true
                                    },
                                    onError = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                            }
                        }
                    }
                )

            }
        }
//        Spacer(modifier = Modifier.height(15.toScaleDp()))
        Column(
            modifier = Modifier.fillMaxSize()
                .padding(start = 75.toScaleDp(), end = 75.toScaleDp(), top = 15.toScaleDp())
                .border(width = 1.toScaleDp(), color = BorderColor, shape = boxCornerShape())
                .background(color = Color.White, shape = boxCornerShape())
        ) {
            Row(modifier = Modifier.fillMaxWidth()) {
                Column(
                    modifier = Modifier
                        .width(210.toScaleDp())
                        .fillMaxHeight()
                        .padding(top = 15.toScaleDp())
                        .drawBehind {
                            drawLine(
                                color = BorderColor,
                                strokeWidth = Dp(1f).toPx(),
                                start = Offset(size.width, 0f),
                                end = Offset(size.width, size.height)
                            )
                        },
                    horizontalAlignment = Alignment.Start
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(48.toScaleDp())
                            .then(
                                if (selectedIndex == 0)
                                    Modifier.background(BlueBackground).drawBehind {
                                        drawLine(
                                            color = BlueApp,
                                            strokeWidth = Dp(6f).toPx(),
                                            start = Offset(Dp(3f).toPx(), 0f),
                                            end = Offset(Dp(3f).toPx(), size.height)
                                        )
                                    }
                                else Modifier)
                            .clickableWithPointer { selectedIndex = 0 },
                        contentAlignment = Alignment.Center
                    ) {
                        DisableSelection {
                            Text(
                                modifier = Modifier.fillMaxWidth().padding(start = 20.toScaleDp()),
                                textAlign = TextAlign.Start,
                                text = stringResource(Res.string.job_details),
                                fontSize = 16.toScaleSp(),
                                color = if (selectedIndex == 0) BlueApp else TextColor,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(48.toScaleDp())
                            .then(
                                if (selectedIndex == 1)
                                    Modifier.background(BlueBackground).drawBehind {
                                        drawLine(
                                            color = BlueApp,
                                            strokeWidth = Dp(6f).toPx(),
                                            start = Offset(Dp(3f).toPx(), 0f),
                                            end = Offset(Dp(3f).toPx(), size.height)
                                        )
                                    }
                                else Modifier)
                            .clickableWithPointer { selectedIndex = 1 },
                        contentAlignment = Alignment.Center
                    ) {
                        DisableSelection {
                            Text(
                                modifier = Modifier.fillMaxWidth().padding(start = 20.toScaleDp()),
                                textAlign = TextAlign.Start,
                                text = stringResource(Res.string.steps),
                                fontSize = 16.toScaleSp(),
                                color = if (selectedIndex == 1) BlueApp else TextColor,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(48.toScaleDp())
                            .then(
                                if (selectedIndex == 2)
                                    Modifier.background(BlueBackground).drawBehind {
                                        drawLine(
                                            color = BlueApp,
                                            strokeWidth = Dp(6f).toPx(),
                                            start = Offset(Dp(3f).toPx(), 0f),
                                            end = Offset(Dp(3f).toPx(), size.height)
                                        )
                                    }
                                else Modifier)
                            .clickableWithPointer { selectedIndex = 2 },
                        contentAlignment = Alignment.Center
                    ) {
                        DisableSelection {
                            Text(
                                modifier = Modifier.fillMaxWidth().padding(start = 20.toScaleDp()),
                                textAlign = TextAlign.Start,
                                text = stringResource(Res.string.files_notes),
                                fontSize = 16.toScaleSp(),
                                color = if (selectedIndex == 2) BlueApp else TextColor,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                }

                Column(modifier = Modifier.fillMaxWidth()) {
                    if (selectedIndex == 0) {
                        Column(
                            modifier = Modifier.padding(
                                start = 16.toScaleDp(),
                                end = 16.toScaleDp()
                            )
                                .width(700.toScaleDp()),
                            verticalArrangement = Arrangement.spacedBy(10.toScaleDp())
                        ) {
                            androidx.compose.material3.Text(
                                text = stringResource(Res.string.job_details),
                                color = Color.Black,
                                fontSize = 24.toScaleSp(),
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier.padding(top = 20.toScaleDp())
                            )
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.contact_name),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                AboutContactDropdown(
                                    viewModel.contactName,
                                    placeholder = stringResource(Res.string.contact_name),
                                    dropdownItems = viewModel.contacts.value,
                                    onContactSelected = { contactId ->
                                        viewModel.contactParentId.value = contactId
                                        viewModel.contactSite.value = ""
                                        viewModel.getContactSites(contactId)
                                    },
                                    modifier = Modifier.weight(3f)
                                )
                            }
                            if (viewModel.contactSites.size > 1) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(
                                        stringResource(Res.string.contact_site),
                                        modifier = Modifier.weight(1f),
                                        maxLines = 1,
                                        fontSize = 14.toScaleSp(),
                                        overflow = TextOverflow.Ellipsis
                                    )
                                    AboutSiteDropdown(
                                        viewModel.contactSite,
                                        stringResource(Res.string.contact_site),
                                        placeholder = stringResource(Res.string.site),
                                        dropdownItems = viewModel.contactSites,
                                        onSiteSelected = { site ->
                                            viewModel.selectedSiteName.value =
                                                site.siteName.toString()
                                            viewModel.contactSiteId.value = site.id.toString()
                                        },
                                        modifier = Modifier.weight(3f)
                                    )
                                }
                            } else {
                                if (viewModel.contactSites.isNotEmpty()) {
                                    viewModel.contactSites[0].siteName?.let {
                                        viewModel.selectedSiteName.value = it
                                    }
                                    viewModel.contactSites[0].id?.let {
                                        viewModel.contactSiteId.value = it
                                    }
                                }
                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.job_title_mandatory),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                AppInputField(
                                    viewModel.jobTitleInput,
                                    placeholder = stringResource(Res.string.enter_job_title),
                                    paddingTop = 0.toScaleDp(),
                                    modifier = Modifier.weight(3f)
                                )
                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.job_status),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                DisableSelection {
                                    AddNewJobDropdownInput(
                                        viewModel.jobStatusValue,
                                        placeholder = stringResource(Res.string.select_job_status),
                                        dropdownItems = viewModel.jobStatusMap,
                                        modifier = Modifier.weight(3f)
                                            .pointerHoverIcon(PointerIcon.Hand),
                                        onValueChange = {
                                            viewModel.jobStatusValue.value = it
                                        }
                                    )
                                }
                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.assign_employee),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                val activeUsers =
                                    users.filter { it.confirmStatus == UserStatus.active.name && it.status == UserStatus.active.name }
                                AssignEmployeeDropdown(
                                    users = activeUsers,
                                    teams = teams,
                                    preSelectedUsers = viewModel.jobSelectedEmployeeList.value,
                                    preSelectedTeams = viewModel.jobSelectedTeamList.value,
                                    onContactSelected = { employee, teams ->
                                        viewModel.jobSelectedEmployeeList.value = employee
                                        viewModel.jobSelectedTeamList.value = teams
                                    },
                                    modifier = Modifier.weight(3f)
                                        .pointerHoverIcon(PointerIcon.Hand),
                                    showLabel = false
                                )
                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.start_date),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                OutlinedCalendarInput(
                                    onClick = {
                                        viewModel.isStartDateCalendarVisible.value = true
                                    },
                                    input = viewModel.startDateInputValue,
                                    modifier = if (!getPlatformChecker().isMobile() && is4K()) Modifier
                                        .fillMaxWidth()
                                        .weight(3f)
                                        .height(56.toScaleDp())
                                        .pointerHoverIcon(PointerIcon.Hand)
                                    else Modifier
                                        .fillMaxWidth()
                                        .weight(3f)
                                        .pointerHoverIcon(PointerIcon.Hand)
                                )
                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.start_at),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                Row(
                                    modifier = if (!getPlatformChecker().isMobile() && is4K()) Modifier
                                        .fillMaxWidth()
                                        .weight(3f)
                                        .height(45.toScaleDp()) else Modifier
                                        .height(56.toScaleDp())
                                        .fillMaxWidth()
                                        .weight(3f),
                                    horizontalArrangement = Arrangement.SpaceBetween,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    OutlinedButton(
                                        onClick = { viewModel.isTimePicker1Visible.value = true },
                                        border = BorderStroke(1.toScaleDp(), InputBorderColor),
                                        shape = RoundedCornerShape(8.toScaleDp()),
                                        colors = ButtonDefaults.outlinedButtonColors(
                                            contentColor = Color.White,
                                            containerColor = Color.Transparent
                                        ),
                                        modifier = Modifier
                                            .fillMaxHeight()
                                            .weight(1f)
                                            .pointerHoverIcon(PointerIcon.Hand)
                                    ) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Text(
                                                text = viewModel.startInputValue.value,
                                                color = Color.DarkGray,
                                                fontSize = 14.toScaleSp(),
                                                textAlign = TextAlign.Start,
                                                modifier = Modifier.weight(4f)
                                            )
                                        }
                                    }

                                    Spacer(modifier = Modifier.width(8.toScaleDp()))

                                    OutlinedButton(
                                        onClick = { viewModel.isTimePicker2Visible.value = true },
                                        border = BorderStroke(1.toScaleDp(), InputBorderColor),
                                        shape = RoundedCornerShape(8.toScaleDp()),
                                        colors = ButtonDefaults.outlinedButtonColors(
                                            contentColor = Color.White,
                                            containerColor = Color.Transparent
                                        ),
                                        modifier = Modifier
                                            .fillMaxHeight()
                                            .weight(1f)
                                            .pointerHoverIcon(PointerIcon.Hand)
                                    ) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Text(
                                                text = viewModel.endInputValue.value,
                                                color = Color.DarkGray,
                                                fontSize = 14.toScaleSp(),
                                                textAlign = TextAlign.Start,
                                                modifier = Modifier.weight(4f)
                                            )
                                        }
                                    }
                                }
                            }
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.repeat),
                                    modifier = Modifier.weight(1f),
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                                DisableSelection {
                                    AddNewJobDropdownInput(
                                        viewModel.repeatValue,
                                        placeholder = stringResource(Res.string.never),
                                        dropdownItems = viewModel.repeatMap,
                                        modifier = Modifier.weight(3f)
                                            .pointerHoverIcon(PointerIcon.Hand),
                                        onValueChange = {
                                            viewModel.isRepeatActive.value =
                                                it != viewModel.repeatMap.entries.find { it.value == Repeat.never.name }?.key
                                        }
                                    )
                                }
                            }
                            if (viewModel.isRepeatActive.value) {
                                val repeatCycle = enumValueOf<Repeat>(
                                    viewModel.repeatMap[viewModel.repeatValue.value]
                                        ?: Repeat.never.name
                                )
                                when (repeatCycle) {
                                    Repeat.never -> {}
                                    Repeat.every_day -> {
                                        Row(
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Text(
                                                stringResource(Res.string.repeat_interval),
                                                modifier = Modifier.weight(1f),
                                                maxLines = 1,
                                                fontSize = 14.toScaleSp(),
                                                overflow = TextOverflow.Ellipsis
                                            )
                                            DisableSelection {
                                                AddNewJobDropdownInput(
                                                    viewModel.repeatDailyValue,
                                                    placeholder = stringResource(Res.string.repeat_interval),
                                                    dropdownItems = viewModel.repeatIntervalMap,
                                                    modifier = Modifier.weight(3f)
                                                )
                                            }
                                        }
                                    }

                                    Repeat.every_week -> {
//                            val days: MutableState<List<String>> =
//                                mutableStateOf(DayOfWeek.entries.map { it.name })
//                            MultiSelectDropdownText(
//                                selectedItems = mutableStateOf(emptyList()),
//                                onItemSelected = { newSelectedItems ->
//                                    viewModel.repeatWeeklyValue.value = newSelectedItems
//                                },
//                                label = stringResource(Res.string.repeat_interval),
//                                placeholder = stringResource(Res.string.repeat_interval),
//                                dropdownItems = days,
//                                preselectedItems = mutableStateOf(emptyList()),
//                                onAddNewItem = { name ->
//
//                                }
//                            )
                                    }

                                    Repeat.every_2_weeks -> {
//                            val days: MutableState<List<String>> =
//                                mutableStateOf(DayOfWeek.entries.map { it.name })
//                            MultiSelectDropdownText(
//                                selectedItems = mutableStateOf(emptyList()),
//                                onItemSelected = { newSelectedItems ->
//                                    viewModel.repeatWeeklyValue.value = newSelectedItems
//                                },
//                                label = stringResource(Res.string.repeat_interval),
//                                placeholder = stringResource(Res.string.repeat_interval),
//                                dropdownItems = days,
//                                preselectedItems = mutableStateOf(emptyList()),
//                                onAddNewItem = { name ->
//
//                                }
//                            )
                                    }

                                    Repeat.every_month -> {
//                            OutlinedCalendarInput(
//                                onClick = {
//                                    viewModel.isCalendarMonthRepeatVisible.value = true
//                                },
//                                input = mutableStateOf(DateTimeUtil.formatSelectedDays(viewModel.repeatMonthValue.value)),
//                                label = stringResource(Res.string.repeat_interval)
//                            )
                                    }

                                    Repeat.custom -> {

                                    }
                                }
                                Row(
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(
                                        stringResource(Res.string.due_date),
                                        modifier = Modifier.weight(1f),
                                        maxLines = 1,
                                        fontSize = 14.toScaleSp(),
                                        overflow = TextOverflow.Ellipsis
                                    )
                                    OutlinedCalendarInput(
                                        onClick = {
                                            viewModel.isDueDateCalendarVisible.value = true
                                        },
                                        input = viewModel.dueDateValue,
                                        modifier = if (!getPlatformChecker().isMobile() && is4K()) Modifier
                                            .fillMaxWidth()
                                            .weight(3f)
                                            .height(56.toScaleDp())
                                        else Modifier
                                            .fillMaxWidth()
                                            .weight(3f)
                                    )
                                }
                            }
                            Spacer(modifier = Modifier.height(20.toScaleDp()))
                        }
                    } else if (selectedIndex == 1) {
                        Column(
                            modifier = Modifier.padding(
                                start = 16.toScaleDp(),
                                end = 16.toScaleDp()
                            )
                        ) {
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            Text(
                                text = stringResource(Res.string.add_steps),
                                fontSize = 18.toScaleSp(),
                                color = TextColor,
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            StepInputFields(viewModel.steps)
                        }
                    } else {
                        Column(
                            modifier = Modifier.padding(
                                start = 16.toScaleDp(),
                                end = 16.toScaleDp(),
                                top = 15.toScaleDp(),
                                bottom = 15.toScaleDp()
                            )
                        ) {
                            Text(
                                text = stringResource(Res.string.notes),
                                fontSize = 18.toScaleSp(),
                                color = TextColor,
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )

                            Column {
                                viewModel.notesListValue.forEach { note ->
                                    AppInputFieldWithUpdate(
                                        note = note,
                                        onNoteChange = { updatedNote ->
                                            val updatedNotes =
                                                viewModel.notesListValue
                                                    .apply {
                                                        val index = indexOf(note)
                                                        if (index != -1) {
                                                            set(index, updatedNote)
                                                        }
                                                    }
                                            viewModel.notesListValue = updatedNotes
                                        },
                                        label = stringResource(Res.string.add_notes),
                                        placeholder = stringResource(Res.string.provide_information),
                                        onNoteDeleted = {
                                            viewModel.notesListValue.remove(note)
                                        }
                                    )
                                }

                                Spacer(modifier = Modifier.height(15.toScaleDp()))
                                DisableSelection {
                                    Text(
                                        text = "+ ${stringResource(Res.string.add_note)}",
                                        fontSize = 16.toScaleSp(),
                                        color = BlueApp,
                                        fontWeight = FontWeight.W700,
                                        textAlign = TextAlign.Center,
                                        modifier = Modifier
                                            .clickableWithPointer {
                                                viewModel.addBlankNote()
                                            }
                                            .padding(8.toScaleDp())
                                    )
                                }
                            }

                            Spacer(modifier = Modifier.height(15.toScaleDp()))
                            Text(
                                text = stringResource(Res.string.files),
                                fontSize = 18.toScaleSp(),
                                color = TextColor,
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Spacer(modifier = Modifier.height(15.toScaleDp()))
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .wrapContentHeight(unbounded = false)
                                    .defaultMinSize(minHeight = 200.toScaleDp())
                                    .align(Alignment.CenterHorizontally)
                                    .drawBehind {
                                        val paint = Paint().apply {
                                            color = BlueApp
                                            style = PaintingStyle.Stroke
                                            strokeWidth = Dp(2f).toPx()
                                            pathEffect =
                                                PathEffect.dashPathEffect(
                                                    floatArrayOf(10f, 10f),
                                                    0f
                                                )
                                        }
                                        drawIntoCanvas { canvas ->
                                            canvas.drawRoundRect(
                                                left = 0f,
                                                top = 0f,
                                                right = size.width,
                                                bottom = size.height,
                                                radiusX = Dp(16f).toPx(),
                                                radiusY = Dp(16f).toPx(),
                                                paint = paint
                                            )
                                        }
                                    },
                                contentAlignment = Alignment.Center
                            ) {
                                Column(
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                    verticalArrangement = Arrangement.Center,
                                    modifier = Modifier.fillMaxSize().clickableWithPointer {
                                        jobId?.let {
                                            onUploadDocumentClick(
                                                it,
                                                DocumentType.JOB_FILE
                                            )
                                        }
                                    }
                                ) {
                                    if (jobId != DEFAULT_JOB_ID && jobId != "") {
                                        if (fileIds.isEmpty()) {
                                            Image(
                                                painter = painterResource(Res.drawable.upload_cloud),
                                                contentDescription = "",
                                                modifier = Modifier.size(40.toScaleDp())
                                            )

                                            Spacer(modifier = Modifier.height(8.toScaleDp()))

                                            DisableSelection {
                                                Text(
                                                    text = stringResource(Res.string.upload_documents),
                                                    color = Color.Black,
                                                    fontWeight = FontWeight.Bold,
                                                    maxLines = 1,
                                                    fontSize = 18.toScaleSp(),
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            }

                                            Spacer(modifier = Modifier.height(4.toScaleDp()))

                                            Text(
                                                text = stringResource(Res.string.max_size),
                                                color = Color.LightGray,
                                                maxLines = 1,
                                                fontSize = 18.toScaleSp(),
                                                overflow = TextOverflow.Ellipsis
                                            )
                                        } else {
                                            Image(
                                                painter = painterResource(Res.drawable.baseline_file_present_24),
                                                contentDescription = "",
                                                modifier = Modifier
                                                    .padding(top = 24.toScaleDp())
                                                    .size(40.toScaleDp())
                                            )
                                            Column(
                                                modifier = Modifier
                                                    .padding(horizontal = 10.toScaleDp())
                                            ) {
                                                for (fileId in fileIds) {
                                                    Row(
                                                        horizontalArrangement = Arrangement.SpaceBetween,
                                                        verticalAlignment = Alignment.CenterVertically,
                                                        modifier = Modifier.fillMaxWidth()
                                                    ) {
                                                        Text(
                                                            text = fileId ?: "",
                                                            color = DarkGrey,
                                                            fontWeight = FontWeight.Normal,
                                                            fontSize = 16.toScaleSp(),
                                                            maxLines = 1,
                                                            overflow = TextOverflow.Ellipsis,
                                                            modifier = Modifier
                                                                .weight(1f)
                                                                .padding(end = 8.toScaleDp())
                                                        )

                                                        DisableSelection {
                                                            Image(
                                                                painter = painterResource(Res.drawable.trash),
                                                                contentDescription = null,
                                                                modifier = Modifier
                                                                    .size(20.toScaleDp())
                                                                    .clickableWithPointer {
                                                                        fileId?.let {
                                                                            viewModel.fileToDeleteId.value =
                                                                                it
                                                                            viewModel.showAreYouSurePopUpDeleteFile.value =
                                                                                true
                                                                        }
                                                                    }
                                                            )
                                                        }
                                                    }
                                                    Spacer(modifier = Modifier.height(10.toScaleDp()))
                                                }
                                            }
                                            Spacer(modifier = Modifier.height(12.toScaleDp()))
                                            DisableSelection {
                                                Text(
                                                    text = stringResource(Res.string.add_more),
                                                    color = BlueApp,
                                                    fontWeight = FontWeight.Bold,
                                                    fontSize = 18.toScaleSp(),
                                                    modifier = Modifier
                                                        .padding(bottom = 24.toScaleDp())
                                                        .clickableWithPointer {
                                                            jobId?.let {
                                                                onUploadDocumentClick(
                                                                    it,
                                                                    DocumentType.JOB_FILE
                                                                )
                                                            }
                                                        },
                                                    maxLines = 1,
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            }
                                        }
                                    } else {
                                        if (fileIds.isEmpty()) {
                                            Image(
                                                painter = painterResource(Res.drawable.upload_cloud),
                                                contentDescription = "",
                                                modifier = Modifier.size(40.toScaleDp())
                                            )

                                            Spacer(modifier = Modifier.height(8.toScaleDp()))

                                            DisableSelection {
                                                Text(
                                                    text = stringResource(Res.string.upload_documents),
                                                    color = Color.Black,
                                                    fontWeight = FontWeight.Bold,
                                                    maxLines = 1,
                                                    fontSize = 18.toScaleSp(),
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            }

                                            Spacer(modifier = Modifier.height(4.toScaleDp()))

                                            Text(
                                                text = stringResource(Res.string.max_size),
                                                color = Color.LightGray,
                                                maxLines = 1,
                                                fontSize = 18.toScaleSp(),
                                                overflow = TextOverflow.Ellipsis
                                            )
                                        } else if (viewModel.isFileUploadError()) {
                                            Text(
                                                text = stringResource(Res.string.try_another_document),
                                                color = Color.Gray,
                                                fontWeight = FontWeight.Normal,
                                                maxLines = 1,
                                                fontSize = 16.toScaleSp(),
                                                overflow = TextOverflow.Ellipsis
                                            )
                                        } else {
                                            Image(
                                                painter = painterResource(Res.drawable.baseline_file_present_24),
                                                contentDescription = "",
                                                modifier = Modifier
                                                    .padding(top = 24.toScaleDp())
                                                    .size(40.toScaleDp())
                                            )
                                            Column(
                                                modifier = Modifier
                                                    .padding(horizontal = 10.toScaleDp())
                                            ) {
                                                for (fileId in fileIds) {
                                                    Row(
                                                        horizontalArrangement = Arrangement.SpaceBetween,
                                                        verticalAlignment = Alignment.CenterVertically,
                                                        modifier = Modifier.fillMaxWidth()
                                                    ) {
                                                        Text(
                                                            text = fileId,
                                                            color = DarkGrey,
                                                            fontWeight = FontWeight.Normal,
                                                            style = MaterialTheme.typography.body1,
                                                            maxLines = 1,
                                                            fontSize = 16.toScaleSp(),
                                                            overflow = TextOverflow.Ellipsis,
                                                            modifier = Modifier
                                                                .weight(1f)
                                                                .padding(end = 8.toScaleDp())
                                                        )

                                                        DisableSelection {
                                                            Image(
                                                                painter = painterResource(Res.drawable.trash),
                                                                contentDescription = null,
                                                                modifier = Modifier
                                                                    .size(20.toScaleDp())
                                                                    .clickableWithPointer {
                                                                        fileId?.let {
                                                                            viewModel.fileToDeleteId.value =
                                                                                it
                                                                            viewModel.showAreYouSurePopUpDeleteFile.value =
                                                                                true
                                                                        }
                                                                    }
                                                            )
                                                        }
                                                    }
                                                    Spacer(modifier = Modifier.height(10.toScaleDp()))
                                                }
                                            }
                                            Spacer(modifier = Modifier.height(12.toScaleDp()))
                                            Text(
                                                text = stringResource(Res.string.add_more),
                                                color = BlueApp,
                                                fontWeight = FontWeight.Bold,
                                                fontSize = 18.toScaleSp(),
                                                modifier = Modifier
                                                    .padding(bottom = 24.toScaleDp())
                                                    .clickableWithPointer {
                                                        onUploadDocumentClick(
                                                            jobId,
                                                            DocumentType.JOB_FILE
                                                        )
                                                    },
                                                maxLines = 1,
                                                overflow = TextOverflow.Ellipsis
                                            )
                                        }
                                    }
                                }
                            }

                            Text(
                                text = stringResource(Res.string.only_support),
                                fontSize = 12.toScaleSp(),
                                color = Color.LightGray,
                                textAlign = TextAlign.Center,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }


                    if (viewModel.isTimePicker1Visible.value) {
                        DisableSelection {
                            CustomTimePicker(
                                time = viewModel.startInputValue.value,
                                onTimeSelected = {
                                    if (it == "") {
                                        viewModel.startInputValue.value = startAtString
                                    } else {
                                        viewModel.startInputValue.value = it
                                    }
                                    viewModel.isTimePicker1Visible.value = false
                                },
                                onDismiss = {
                                    viewModel.isTimePicker1Visible.value = false
                                },
                                showClear = viewModel.startInputValue.value != startAtString
                            )
                        }
                    }
                    val errorString = stringResource(Res.string.start_end_time)
                    val startRequiredString = stringResource(Res.string.job_start_time_error)
                    if (viewModel.isTimePicker2Visible.value) {
                        DisableSelection {
                            CustomTimePicker(
                                time = viewModel.endInputValue.value,
                                onDismiss = {
                                    viewModel.isTimePicker2Visible.value = false
                                },
                                onTimeSelected = { selectedTime ->
                                    if (selectedTime == "") {
                                        viewModel.endInputValue.value = endAtString
                                        viewModel.isTimePicker2Visible.value = false
                                    } else if (viewModel.startInputValue.value == startAtString) {
                                        viewModel.errorText.value = startRequiredString
                                        viewModel.showPopUpError.value = true
                                        viewModel.endInputValue.value = endAtString
                                    } else if (selectedTime == viewModel.startInputValue.value || selectedTime < viewModel.startInputValue.value) {
                                        viewModel.errorText.value = errorString
                                        viewModel.showPopUpError.value = true
                                        viewModel.endInputValue.value = endAtString
                                    } else {
                                        viewModel.endInputValue.value = selectedTime
                                        // viewModel.calculateDuration()
                                        viewModel.isTimePicker2Visible.value = false
                                    }
                                },
                                defaultTime = "16:00",
                                showClear = viewModel.endInputValue.value != endAtString
                            )
                        }
                    }
                    val error = stringResource(Res.string.date_error)
                    if (viewModel.isStartDateCalendarVisible.value) {
                        DisableSelection {
                            CustomCalendarView(
                                isMultiDay = false,
                                selectionMode = SelectionMode.Single,
                                onDismiss = { viewModel.isStartDateCalendarVisible.value = false },
                                onDateSelect = {
                                    if (it.isNotEmpty()) {
                                        viewModel.startDateInputValue.value = it[0].toString()
                                    }
                                },
                                showErrorMessage = {
                                    viewModel.showPopUpError.value = true
                                    viewModel.errorText.value = error
                                })
                        }
                    }
                    if (viewModel.isDueDateCalendarVisible.value) {
                        DisableSelection {
                            CustomCalendarView(
                                isMultiDay = false,
                                selectionMode = SelectionMode.Single,
                                startDate = try {
                                    LocalDate.parse(viewModel.startDateInputValue.value)
                                } catch (e: Exception) {
                                    Clock.System.todayIn(TimeZone.currentSystemDefault())
                                },
                                minDate = try {
                                    LocalDate.parse(viewModel.startDateInputValue.value)
                                } catch (e: Exception) {
                                    Clock.System.todayIn(TimeZone.currentSystemDefault())
                                },
                                onDismiss = { viewModel.isDueDateCalendarVisible.value = false },
                                onDateSelect = {
                                    if (it.isNotEmpty()) {
                                        viewModel.dueDateValue.value = it[0].toString()
                                    }
                                },
                                showErrorMessage = {
                                    viewModel.showPopUpError.value = true
                                    viewModel.errorText.value = error
                                })
                        }
                    }
                    if (viewModel.showPopUpSuccess.value) {
                        DisableSelection {
                            PopUpDialog(
                                onDismiss = {
                                    viewModel.showPopUpSuccess.value = false
                                    navHostController.popBackStack()
                                },
                                title = stringResource(Res.string.success).uppercase(),
                                message = if (jobId == DEFAULT_JOB_ID || jobId == "") stringResource(
                                    Res.string.job_added
                                ) else stringResource(
                                    Res.string.job_updated
                                ),
                                onPositiveBtnClicked = {
                                    viewModel.showPopUpSuccess.value = false
                                    navHostController.popBackStack()
                                },
                                positiveBtnText = stringResource(Res.string.ok)
                            )
                        }
                    }
                    if (viewModel.showPopUpError.value) {
                        DisableSelection {
                            ErrorDialog(
                                onDismiss = { viewModel.showPopUpError.value = false },
                                title = stringResource(Res.string.error).uppercase(),
                                message = viewModel.errorText.value
                            )
                        }
                    }
                    if (viewModel.showLoader.value) {
                        DisableSelection {
                            FullScreenProgressBar()
                        }
                    }

                    if (viewModel.showAreYouSurePopUpDeleteJob.value) {
                        DisableSelection {
                            PopUpDialog(
                                onDismiss = {
                                    viewModel.showAreYouSurePopUpDeleteJob.value = false
                                },
                                title = stringResource(Res.string.confirmation),
                                message = stringResource(Res.string.are_you_sure),
                                onPositiveBtnClicked = {
                                    viewModel.selectedJobIdToDelete.value?.let { id ->
                                        viewModel.deleteJob(
                                            id,
                                            onSuccess = {
                                                viewModel.showJobDeleteSuccess.value = true
                                            },
                                            onError = {
                                                viewModel.showPopUpError.value = true
                                            })
                                    }
                                    viewModel.showAreYouSurePopUpDeleteJob.value = false
                                },
                                onNegativeBtnClicked = {
                                    viewModel.showAreYouSurePopUpDeleteJob.value = false
                                },
                                positiveBtnText = stringResource(Res.string.delete),
                                negativeBtnText = stringResource(Res.string.cancel)
                            )
                        }
                    }
                    if (viewModel.showJobDeleteSuccess.value) {
                        DisableSelection {
                            PopUpDialog(
                                onDismiss = {
                                    viewModel.showJobDeleteSuccess.value = false
                                    navHostController.popBackStack()
                                    navHostController.popBackStack()
                                },
                                title = stringResource(Res.string.success).uppercase(),
                                message = stringResource(Res.string.job_deleted),
                                onPositiveBtnClicked = {
                                    viewModel.showJobDeleteSuccess.value = false
                                    navHostController.popBackStack()
                                    navHostController.popBackStack()
                                },
                                positiveBtnText = stringResource(Res.string.ok)
                            )
                        }
                    }
                    if (viewModel.showAreYouSurePopUpDeleteFile.value) {
                        PopUpDialog(
                            onDismiss = { viewModel.showAreYouSurePopUpDeleteFile.value = false },
                            title = stringResource(Res.string.confirmation),
                            message = stringResource(Res.string.are_you_sure),
                            onPositiveBtnClicked = {
                                viewModel.fileToDeleteId.value?.let {
                                    viewModel.deleteUploadedFile(it)
                                }
                                viewModel.showAreYouSurePopUpDeleteFile.value = false
                            },
                            onNegativeBtnClicked = {
                                viewModel.showAreYouSurePopUpDeleteFile.value = false
                            },
                            positiveBtnText = stringResource(Res.string.delete),
                            negativeBtnText = stringResource(Res.string.cancel)
                        )
                    }
                }
            }
        }
    }
}
